module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-app', [_c('v-content', [_c('v-container', [_c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Edit Permission")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Action",
      "rules": _vm.actionRules,
      "required": ""
    },
    model: {
      value: (_vm.editedItem.action),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "action", $$v)
      },
      expression: "editedItem.action"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.permissions,
      "pagination": _vm.pagination,
      "total-items": _vm.totalPermissions,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(ref) {
        var header = ref.header;

        return [_c('span', {
          staticClass: "body-2 font-weight-regular accent--text",
          domProps: {
            "textContent": _vm._s(header.text)
          }
        })]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.createdAt))])]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v(" No data Found ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.getDataFromApi
    }
  }, [_vm._v("Reload")])], 1)], 2)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66dcfaa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/viewpermissions.vue
// module id = 1064
// module chunks = 2